import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./GroupNotesModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import InfoItem from "shared/InfoItem";

/**
 * Interactive component. Modal used to create and edit notes.
 */

export function GroupNotesModal({
  isOpen,
  onClose,
  onClick,
  note,
  groupInfo,
  edit,
}) {
  const [noteValue, setNoteValue] = useState(note);

  return (
    <>
      <div className={styles.container}>
        <Modal
          isOpen={isOpen}
          title="NOTES"
          closeBtn="none"
          className={styles.modal}
        >
          {!edit ? (
            <>
              <div className={styles.editBtnContainer}>
                <ModalActionBar
                  children={
                    <div className={styles.btnDiv}>
                      <button
                        type="button"
                        className={styles.editBtn}
                        onClick={onClick}
                      >
                        EDIT
                      </button>
                    </div>
                  }
                />
              </div>
            </>
          ) : (
            <>
              <div className={styles.hide}></div>
            </>
          )}

          <div className={styles.infoContainer}>
            <div className={styles.infoDiv}>
              <InfoItem label="Group Name" description={groupInfo.name} />
            </div>
            <div className={styles.infoDiv}>
              <InfoItem label="Group ID" description={groupInfo.id} />
            </div>

            {!edit ? (
              <>
                <div className={styles.infoDiv}>
                  <InfoItem label="Notes" description={groupInfo.notes} />
                </div>
                <div className={styles.btnContainer}>
                  <ModalActionBar
                    children={
                      <div className={styles.btnDiv}>
                        <button
                          type="button"
                          className={styles.closeBtn}
                          onClick={onClose}
                        >
                          CLOSE
                        </button>
                      </div>
                    }
                  />
                </div>
              </>
            ) : (
              <>
                <div className={styles.noteDiv}>
                  <label className={styles.label} htmlFor={note}>
                    Notes
                  </label>
                  <textarea
                    className={styles.textarea}
                    placeholder="Click to type a note"
                    onChange={(e) => setNoteValue(e.target.value)}
                    value={noteValue}
                  />
                </div>
                <div className={styles.btnContainer}>
                  <ModalActionBar
                    children={
                      <div className={styles.btnDiv}>
                        <button
                          type="button"
                          className={styles.closeBtn}
                          onClick={() => {
                            alert("Save notes clicked");
                          }}
                        >
                          SAVE
                        </button>
                      </div>
                    }
                  />
                </div>
              </>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
}

GroupNotesModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when edit is clicked
   */
  onClick: PropTypes.func,

  /**
   * Object with the groups info
   */
  groupInfo: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    groupType: PropTypes.string,
    status: PropTypes.string,
    pluginType: PropTypes.string,
    notes: PropTypes.string,
  }),
  /**
   * 	To determine the modal to show
   */
  edit: PropTypes.bool,
};
